var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-modal",
    {
      staticClass: "modalRetificao",
      attrs: { titulo: "Solicitar Retificação", width: _vm.width },
      on: { closeModal: _vm.closeModal }
    },
    [
      _c(
        "template",
        { slot: "body" },
        [
          _c("h4", [
            _vm._v(
              "Assunto: Solicitar Retificação - Processo n° " +
                _vm._s(_vm.numeroProcesso)
            )
          ]),
          _c("app-label", {
            attrs: {
              label: "Especifique os campos a serem retificados no cadastro:",
              required: true
            }
          }),
          _c(
            "validation-observer",
            { ref: "validation", attrs: { tag: "form" } },
            [
              _c("validation-provider", {
                attrs: { rules: "required" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-editor-texto", {
                          staticClass: "input",
                          class: { erro: errors.length },
                          attrs: { value: _vm.conversa },
                          on: { onTextChange: _vm.setConversa }
                        }),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              }),
              _c(
                "h4",
                [
                  _vm._v("Anexos mensagem"),
                  _c("app-anexo", {
                    attrs: {
                      id: "upload-notificacao",
                      exibirDownload: false,
                      files: _vm.anexos,
                      scope: "anexos"
                    },
                    on: {
                      removeFile: _vm.removeFile,
                      uploadFile: _vm.uploadFile
                    },
                    model: {
                      value: _vm.anexos,
                      callback: function($$v) {
                        _vm.anexos = $$v
                      },
                      expression: "anexos"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("template", { slot: "footer" }, [
        _c(
          "div",
          { staticClass: "flex" },
          [
            _c(
              "el-button",
              {
                staticClass: "btn",
                attrs: { type: "default", size: "small" },
                on: { click: _vm.closeModal }
              },
              [
                _c("span", { staticClass: "center" }, [
                  _c("i", { staticClass: "fa fa-times" }),
                  _c("b", [_vm._v("  Cancelar")])
                ])
              ]
            ),
            _c(
              "el-button",
              {
                staticClass: "btn",
                attrs: { type: "success", size: "small" },
                on: { click: _vm.enviar }
              },
              [
                _c("span", { staticClass: "center" }, [
                  _c("i", { staticClass: "fa fa-share-square" }),
                  _c("b", [_vm._v("  Enviar")])
                ])
              ]
            )
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f0e6ede8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f0e6ede8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/components/modal/AppModalSolicitarRetificacao.vue
// module id = null
// module chunks = 